var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {\n  color: #12bcf1 !important;\n}\n.polsize {\n  font-size: 12px;\n}\n.icon-account-red-bank {\n  background-image: url(" + escape(require("../../assets/static/images/banks.png")) + ");\n}\n.icon-account-green-bank {\n  background-image: url(" + escape(require("../../assets/static/images/account.png")) + ");\n}\n.rowBackgroundImage {\n  background-image: url(" + escape(require("../../assets/static/images/MenuFont.png")) + ");\n  background-size: contain;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a8660e88","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMImportBankAccountReport.vue
// module id = 1160
// module chunks = 2